import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { PlaneRoutePage } from "../app/planeRoute";

export const Route = createFileRoute("/events")({
  component: EventsRoute,
});

function EventsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <PlaneRoutePage kindId="events" search={search} />;
}
